import React from "react";
import { formatAssetInt } from "../utils/assetUtils";

export const ClaimPreviewModal = React.memo(function ClaimPreviewModal({
  isOpen,
  claimCalc,
  claimCalcLoading,
  claimCalcError,
  saveError,
  onConfirm,
  onCancel,
  busy,
  mode = "save", // 'save' | 'info'
}) {
  if (!isOpen) return null;

  return (
    <div className="nr-modalOverlay" onClick={onCancel}>
      <div className="nr-modal" onClick={(e) => e.stopPropagation()}>
        <div className="nr-modalHeader">
          <div className="nr-modalTitle">Claim Preview</div>
        </div>
        <div className="nr-modalBody">
          {claimCalcLoading ? (
            <div className="nr-muted">Calculating claim statistics...</div>
          ) : claimCalcError && !claimCalc ? (
            <div className="nr-error">{claimCalcError}</div>
          ) : (
            <div>
              {claimCalcError ? (
                <div className="nr-error" style={{ marginBottom: 16 }}>
                  {claimCalcError}
                </div>
              ) : null}
              {claimCalc ? (
                <>
              <p style={{ marginTop: 0, marginBottom: 16 }}>
                <strong>These changes will result in the following claim statistics:</strong>
              </p>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12, marginBottom: 16 }}>
                <div className="nr-chip" style={{ borderRadius: 14, padding: 12, background: "rgba(255,255,255,.04)" }}>
                  <div className="nr-muted">Eligible NFTs</div>
                  <div style={{ fontWeight: 900, fontSize: 18 }}>{claimCalc.eligibleNfts}</div>
                  <div className="nr-muted" style={{ marginTop: 4, fontSize: 11 }}>
                    {claimCalc.poolAssetsTotal > 0 ? (
                      <>
                        Scanned: {claimCalc.poolAssetsTotal} assets{claimCalc.excludedAssetsCount ? ` (excluded: ${claimCalc.excludedAssetsCount})` : ""}
                        {claimCalc.poolImmutableRulesCount || claimCalc.poolMutableRulesCount ? (
                          <>
                            <br />
                            Filters: {claimCalc.poolImmutableRulesCount || 0} immutable
                            {claimCalc.poolMutableRulesCount ? `, ${claimCalc.poolMutableRulesCount} mutable` : ""}
                          </>
                        ) : null}
                      </>
                    ) : null}
                  </div>
                </div>
                <div className="nr-chip" style={{ borderRadius: 14, padding: 12, background: "rgba(255,255,255,.04)" }}>
                  <div className="nr-muted">Eligible Wallets</div>
                  <div style={{ fontWeight: 900, fontSize: 18 }}>{claimCalc.eligibleWallets ?? 0}</div>
                  <div className="nr-muted" style={{ marginTop: 4, fontSize: 11 }}>
                    Can claim
                  </div>
                </div>
                <div className="nr-chip" style={{ borderRadius: 14, padding: 12, background: "rgba(255,255,255,.04)" }}>
                  <div className="nr-muted">Already claimed</div>
                  <div style={{ fontWeight: 900, fontSize: 18 }}>{claimCalc.claimedEligibleNfts}</div>
                  <div className="nr-muted" style={{ marginTop: 4, fontSize: 11 }}>
                    {claimCalc.claimedAccounts} accounts
                  </div>
                </div>
                <div className="nr-chip" style={{ borderRadius: 14, padding: 12, background: "rgba(255,255,255,.04)" }}>
                  <div className="nr-muted">Remaining</div>
                  <div style={{ fontWeight: 900, fontSize: 18 }}>{claimCalc.remainingEligibleNfts}</div>
                  <div className="nr-muted" style={{ marginTop: 4, fontSize: 11 }}>
                    Still available
                  </div>
                </div>
              </div>
              {claimCalc.reward ? (
                <div style={{ marginTop: 16, padding: 12, background: "rgba(255,255,255,.02)", borderRadius: 12, border: "1px solid rgba(255,255,255,.08)" }}>
                  <div style={{ marginBottom: 8, fontWeight: 700 }}>Token Statistics:</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span className="nr-muted">Total potential:</span>
                      <span style={{ fontWeight: 600 }}>
                        {formatAssetInt(claimCalc.totalPotential, claimCalc.reward.precision, claimCalc.reward.symbol)}
                      </span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span className="nr-muted">Already claimed:</span>
                      <span style={{ fontWeight: 600 }}>
                        {formatAssetInt(claimCalc.claimedSum, claimCalc.reward.precision, claimCalc.reward.symbol)}
                      </span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4, paddingTop: 8, borderTop: "1px solid rgba(255,255,255,.08)" }}>
                      <span style={{ fontWeight: 700 }}>Remaining:</span>
                      <span style={{ fontWeight: 900, fontSize: 16 }}>
                        {formatAssetInt(claimCalc.remainingPotential, claimCalc.reward.precision, claimCalc.reward.symbol)}
                      </span>
                    </div>
                  </div>
                  <div style={{ marginTop: 12, paddingTop: 8, borderTop: "1px solid rgba(255,255,255,.08)", fontSize: 12, color: "var(--nr-muted)" }}>
                    {claimCalc.isMaxCooldown ? "1 Claim per Wallet" : "1 Claim per NFT"}
                  </div>
                </div>
              ) : null}
              {claimCalc.activeRulesCount > 0 ? (
                <div style={{ marginTop: 12, fontSize: 12, color: "var(--nr-muted)" }}>
                  {claimCalc.activeRulesCount} active dependent NFT rule{claimCalc.activeRulesCount !== 1 ? "s" : ""} considered
                </div>
              ) : null}
                </>
              ) : (
                <div className="nr-muted">No data available</div>
              )}
            </div>
          )}
        </div>
        {saveError && mode === "save" ? (
          <div className="nr-error" style={{ margin: "0 16px 12px" }}>
            {saveError}
          </div>
        ) : null}
        <div className="nr-modalActions">
          {mode === "save" ? (
            <>
              <button className="nr-btn" onClick={onCancel} disabled={busy}>
                Cancel
              </button>
              <button
                className="nr-btn nr-btnPrimary"
                onClick={onConfirm}
                disabled={busy || claimCalcLoading || !claimCalc}
              >
                Continue &amp; Save
              </button>
            </>
          ) : (
            <button
              className="nr-btn nr-btnPrimary"
              onClick={onCancel}
              disabled={busy || claimCalcLoading}
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
});
